import errors from './errors/index.js';
import translation from './translation/index.js';
const ar = {
    translation,
    errors,
};
export default Object.freeze(ar);
